import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import { UserContext } from "./Auth/UserContextProvider";

function AdminRoute({ component: Component, ...rest }) {
  const { isAdmin } = useContext(UserContext);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAdmin ? <Component {...props} /> : <Redirect to="/home" />
      }
    />
  );
}

export default AdminRoute;
